enum MiniConfigurationSummaryIconTypeEnum {
	primaryInverted = 'primaryInverted',
	tertiary = 'tertiary'
}

export default MiniConfigurationSummaryIconTypeEnum;
